<template>
  <v-container fluid ma-0 pa-0>
      <v-row>
        <v-col cols="6" class="pa-0 d-flex align-center justify-center" style="background-color: #f1f4f6">
          <div style="width: 406px">
            <v-img :src="require('@/assets/images/logo_color.png')" width="250px" eager style="margin: auto"></v-img>
            <h2 class="pt-4 pb-4" style="text-align:center;">ドローンレポートシステム</h2>
            <v-divider class="mb-10"></v-divider>
            <h3 class="text-center">ログイン</h3>
            <v-form
              ref="logInForm"
              v-model="logInValid"
              >
                  <v-col cols="12" style="padding: 6px 0px;">
                  <v-text-field
                      label="メール*"
                      required
                      outlined
                      dense
                      :rules="emailRules"
                      v-model="inputLogIn.email"
                      style="padding-top:0px;"
                  ></v-text-field>
                  </v-col>
                  <v-col cols="12" style="padding: 6px 0px;">
                  <v-text-field
                      label="パスワード*"
                      :type="showPassword ? 'text' : 'password'"
                      required
                      outlined
                      dense
                      :rules="passRules"
                      v-model="inputLogIn.password"
                      style="padding-top:0px;"
                      hide-details="auto"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                      counter
                      clearable
                  ></v-text-field>
                  </v-col>
            </v-form>
            <v-row class="mb-6" no-gutters>
              <v-col md="4">
                <v-btn text color="primary" style="padding-left:0px;" @click="showResetPassword()">パスワード忘れた場合？</v-btn>
              </v-col>
            </v-row>
            <v-btn color="primary" style="width:100%;" @click="login()">ログイン</v-btn>
          </div>
        </v-col>
        <v-col cols="6" class="pa-0">
          <v-img src="../assets/images/cover.jpg" height="calc(100vh)" class="grey lighten-2"></v-img> 
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogResetPassword"
        persistent
        max-width="500px"
      >
      <v-card>
        <v-card-title>
          パスワードリセット確認
        </v-card-title>
        <v-card-text>
          <p class="mb-2">
            メールアドレスを入力してください。<br>
            新しいパスワードを作成するためのリンクをメールで送ります。
          </p>
          <v-container class="pa-0">
            <v-form
              ref="resetPassForm"
              v-model="resetPassFormValid"
              lazy-validation
            >
              <v-text-field
                  hide-details="auto"
                  outlined
                  dense
                  clearable
                  v-model="resetPasswordEmail"
                  label="メール＊"
                  required
                  :rules="emailRules"
              ></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" depressed>キャンセル</v-btn>
          <v-btn color="primary" @click="resetPassword()" depressed>
            <v-icon left>mdi-lock-reset</v-icon>
            リセット
          </v-btn>
        </v-card-actions>
      </v-card>
      
      </v-dialog>
  </v-container>
</template>

<script>
import {store} from '../store';

export default {
  name: "Login",
  data() {
    return {
      sharedState: store.state,
      inputLogIn: {
        username: null,
        email: null,
        password: null,
      },
      logInValid: true,

      inputSignUp: {
          username: null,
          email: null,
          password1: null,
          password2: null,
      },
      signUpValid: true,

      user: {},

      dialogResetPassword: false,
      resetPasswordEmail: null,
      resetPassFormValid: true,
      emailRules: [
        value => (!!value && !!value.trim()) || 'メルアドレスを入力してください。',
        value => (!!value && value.length <= 50) || 'メールアドレスの長さは50文字以内にしてください。',
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '有効なメールアドレスを入力してください。'
        }
      ],
      passRules: [
        v => (!!v && !!v.trim()) || 'パスワードを入力してください。',
        v => (!!v && v.length >= 8) || '8文字以上のパスワードを入力してください。',
        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(v) || '大文字1つ、小文字1つ、数字1つを最低限含む8文字以上のパスワードを入力してください。',
      ],
      showPassword: false
    };
  },

  methods: {
    login() {
      if (this.$refs.logInForm.validate()) {
        this.inputLogIn.username = this.inputLogIn.email;
        this.axios.post("/api/dj-rest-auth/login/", this.inputLogIn)
        .then((response) => {
          if (response.data.user.is_staff) {
            store.updateLoginStatus(response.data.user.email, "ADMIN", response.data.access_token, response.data.refresh_token);
          } 
          else {
            store.updateLoginStatus(response.data.user.email, "MEMBER", response.data.access_token, response.data.refresh_token);
          }
          this.axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.access_token}`;
          if (this.$route.query.nextUrl != null) {
            this.$router.push(this.$route.query.nextUrl);
          } else {
            this.$router.push("/");
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            if ('non_field_errors' in error.response.data) {
              store.showErrorDialog(error.response.data.non_field_errors[0]);
            }
          } else {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          }
        });
      }
    },

    showResetPassword() {
      this.dialogResetPassword = true;
    },

    resetPassword() {
      if (this.$refs.resetPassForm.validate()) {
        this.axios.post("/api/password/reset/", {email: this.resetPasswordEmail})
        .then(() => {
          store.showSuccessDialog("パスワードリセットのメールを送りました。ご確認ください。");
          this.close();
        })
        .catch(() =>{
          store.showErrorDialog("エラーが発生しました。再度試してください。");
        });
        }
      
    },

    close() {
      this.dialogResetPassword = false;
      this.$refs.resetPassForm.reset();
      this.$emit("input");
    },
    
  },

  created() {
    if (this.sharedState.email){
      const token = this.sharedState.token;
      this.axios
          .post("/api/dj-rest-auth/logout/", { access_token: token })
          .then(() => {
            store.updateLogoutStatus();
            this.axios.defaults.headers.common["Authorization"] = "";
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          });
    }
  },
};
</script>

<style scoped>
.g-signin-button {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #f70707;
  color: #fff;
  box-shadow: 0 3px 0 #f70707;
  width: 100%;
  text-align: center;
}

.divider{
  display: flex;
  align-items: center;
}

.divider:after,
.divider:before {
  content: "";
  flex-grow: 1;
  height: 1px;
  background: rgba(0, 0, 0, 0.87);
}
</style>
